import React from 'react'
import style from '../startedsoon/startsoon.module.css'

function Geographybymayank() {
  return (
    <div className = {style.start_soon}>
        <img src='https://edge.uacdn.net/static/thumbnail/course/05b30dd5b1154688b17c563e9366c6b9.png?q=100&w=512' alt='_Sumit_img'/>
        <div>
        <p>HINDI    SCIENCE</p>
        <h4>Course on World Geography for NDA I - 2022</h4> 
        <p>Lesson 12 • Today, 9:05 PM</p> 
        <p>Mayank Parashar</p>  
        </div>
    </div>        
  )
}
export default Geographybymayank;